"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initDefaultInputs = exports.resolveAggregators = exports.resolveAggregator = exports.normalizeAggregators = exports.buildFormData = exports.formReducer = exports.getInputStage = exports.inputsReducer = exports.defaultController = exports.AggregateDataContext = exports.FormPageContext = exports.InternalFormIdContext = exports.InternalFormContext = exports.InternalFormDispatchContext = void 0;
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
exports.InternalFormDispatchContext = (0, react_1.createContext)(null);
exports.InternalFormContext = (0, react_1.createContext)(undefined);
exports.InternalFormIdContext = (0, react_1.createContext)(null);
exports.FormPageContext = (0, react_1.createContext)(null);
exports.AggregateDataContext = (0, react_1.createContext)(null);
const defaultController = (value = '') => ({
    value,
    defaultValue: value,
    setValue() {
    },
    setError() {
    },
    __defaultController: true,
});
exports.defaultController = defaultController;
exports.inputsReducer = {
    SET_INPUT: (state, [name, update]) => ({
        [name]: Object.assign(Object.assign({}, state[name]), update),
    }),
    REMOVE_INPUT: (_, name) => ({ [name]: undefined }),
    RESET: (_a) => {
        var { dispatch } = _a, inputs = __rest(_a, ["dispatch"]);
        (0, utils_1.map)((input) => (input === null || input === void 0 ? void 0 : input.value) === (input === null || input === void 0 ? void 0 : input.defaultValue)
            ? input
            : Object.assign(Object.assign({}, input), { value: input.defaultValue }), inputs);
    },
};
function getInputStage(input = (0, exports.defaultController)()) {
    return input.__defaultController
        ? 'NOT_REGISTERED'
        : input.deactivated || input.unmounted
            ? 'DEACTIVATED'
            : 'REGISTERED';
}
exports.getInputStage = getInputStage;
exports.formReducer = {
    REGISTER_INPUT: ({ inputs, dispatch }, { name, value: valueProp, validate, serialize, parse, pageId, aggregator, noSubmit, __defaultController, }) => {
        var _a, _b;
        const controller = inputs.getState()[name];
        const inputValue = (_a = controller === null || controller === void 0 ? void 0 : controller.value) !== null && _a !== void 0 ? _a : valueProp;
        switch (getInputStage(controller)) {
            case 'NOT_REGISTERED': {
                {
                    const value = (_b = parse === null || parse === void 0 ? void 0 : parse(inputValue)) !== null && _b !== void 0 ? _b : inputValue;
                    if ((0, utils_1.isNullish)(value)) {
                        return;
                    }
                    inputs.dispatch('SET_INPUT', [
                        name,
                        {
                            defaultValue: value,
                            noSubmit,
                            value,
                            validate,
                            serialize,
                            error: validate === null || validate === void 0 ? void 0 : validate(value),
                            page: pageId !== null && pageId !== void 0 ? pageId : undefined,
                            aggregator: aggregator !== null && aggregator !== void 0 ? aggregator : undefined,
                            setError: (e) => dispatch('UPDATE_INPUT', { name, error: e }),
                            setValue: (newValue) => dispatch('UPDATE_INPUT', { name, value: newValue }),
                            __defaultController,
                        },
                    ]);
                }
                break;
            }
            case 'DEACTIVATED': {
                inputs.dispatch('SET_INPUT', [
                    name,
                    {
                        validate,
                        error: validate === null || validate === void 0 ? void 0 : validate(inputValue),
                        unmounted: false,
                        deactivated: false,
                        noSubmit,
                    },
                ]);
                break;
            }
            default:
        }
    },
    UNREGISTER_INPUT: ({ inputs, activePage, mountedRef }, name) => {
        const controller = inputs.getState()[name];
        if (mountedRef.current && controller) {
            inputs.dispatch('SET_INPUT', [
                name,
                Object.assign({}, (controller.page === activePage
                    ? { deactivated: true }
                    : { unmounted: true })),
            ]);
        }
    },
    REMOVE_INPUT: ({ inputs }, name) => {
        inputs.dispatch('REMOVE_INPUT', name);
    },
    UPDATE_INPUT: ({ inputs }, _a) => {
        var { name } = _a, updates = __rest(_a, ["name"]);
        const controller = inputs.getState()[name];
        if (controller) {
            const update = Object.assign({}, updates);
            if (typeof update.value === 'function') {
                update.value = update.value(controller.value);
            }
            inputs.dispatch('SET_INPUT', [name, update]);
            if ((0, utils_1.has)(update, 'value')) {
                return { success: undefined };
            }
        }
    },
    REGISTER_PAGE: ({ pages, activePage, successPage, startPage }, { pageId, options }) => {
        if (successPage) {
            return { fatal: 'successPage must be the last page!' };
        }
        const pageNumber = pages.length + 1;
        return Object.assign({ activePage: startPage
                ? pageNumber === startPage
                    ? pageId
                    : activePage
                : activePage !== null && activePage !== void 0 ? activePage : pageId }, ((options === null || options === void 0 ? void 0 : options.successPage)
            ? { successPage: pageId }
            : { pages: [...pages, pageId] }));
    },
    UNREGISTER_PAGE: ({ mountedRef }) => {
        console.assert(mountedRef.current, 'Critical: You just unmounted one of the Form Pages.\n  It may lead to unexpected behaviour. You have to unmount the whole Form component instead.');
    },
    SET_ACTIVE_PAGE: ({ pages, successPage }, pageNumber) => ({
        activePage: pages[pageNumber - 1] || successPage,
    }),
    REGISTER_AGGREGATOR: ({ aggregators }, { name, aggregate, validate, parent, pageId }) => {
        var _a, _b;
        if (((_a = aggregators[name]) === null || _a === void 0 ? void 0 : _a.registered) &&
            aggregate === aggregators[name].aggregate) {
            const { page, unmounted, deactivated } = aggregators[name];
            if (pageId !== page || (!unmounted && !deactivated)) {
                return { fatal: `Duplicate aggregator "${name}"` };
            }
        }
        return {
            aggregators: Object.assign(Object.assign({}, aggregators), (parent
                ? {
                    [parent]: Object.assign(Object.assign({}, aggregators[parent]), { children: Object.assign(Object.assign({}, (_b = aggregators[parent]) === null || _b === void 0 ? void 0 : _b.children), { [name]: { aggregate, validate, children: {} } }) }),
                    [name]: Object.assign(Object.assign({}, aggregators[name]), { registered: true, page: pageId !== null && pageId !== void 0 ? pageId : undefined, aggregate,
                        validate }),
                }
                : { [name]: Object.assign(Object.assign({}, aggregators[name]), { aggregate, validate }) })),
        };
    },
    UNREGISTER_AGGREGATOR: ({ aggregators, activePage, mountedRef }, name) => {
        if (mountedRef.current && aggregators[name]) {
            return {
                aggregators: Object.assign(Object.assign({}, aggregators), { [name]: Object.assign(Object.assign({}, aggregators[name]), (aggregators[name].page === activePage
                        ? { deactivated: true }
                        : { unmounted: true })) }),
            };
        }
    },
    REMOVE_AGGREGATOR: ({ aggregators }, name) => {
        if (aggregators[name]) {
            const { children } = aggregators[name];
            const getAdjacentChildren = (deepChildren) => deepChildren
                ? Object.keys(deepChildren).reduce((acc, key) => {
                    var _a;
                    const c = (_a = aggregators[key]) === null || _a === void 0 ? void 0 : _a.children;
                    return [
                        ...acc,
                        key,
                        ...(c && Object.keys(c).length > 0
                            ? getAdjacentChildren(c)
                            : []),
                    ];
                }, [])
                : [];
            const adjacentChildren = getAdjacentChildren(children);
            return {
                aggregators: (0, utils_1.omit)(Object.fromEntries(Object.entries(aggregators).reduce((acc, [key, aggregator]) => key === name
                    ? acc
                    : [
                        ...acc,
                        [
                            key,
                            Object.assign(Object.assign({}, aggregator), { children: (0, utils_1.omit)(aggregator.children, name) }),
                        ],
                    ], [])), ...adjacentChildren),
            };
        }
    },
    CLEAR_FORM: ({ inputs, pages, successPage }, success) => {
        inputs.dispatch('RESET');
        return {
            activePage: (success && successPage) || pages[0],
            success,
        };
    },
    SET_STATE: (_, update) => update,
};
function buildFormData(inputs) {
    return Object.entries(inputs).reduce((acc, [name, input]) => {
        var _a;
        const { value, deactivated, serialize = (v) => v, aggregator, noSubmit, } = input;
        const shouldSubmit = !deactivated && !noSubmit;
        if (shouldSubmit) {
            (0, utils_1.set)(acc.allData, name, serialize(value));
            const scopes = name.split('.').slice(0, -1);
            const unscope = Boolean(aggregator && !((_a = scopes[0]) === null || _a === void 0 ? void 0 : _a.startsWith('lang_')));
            (0, utils_1.set)(aggregator ? acc.toAggregate : acc, aggregator !== null && aggregator !== void 0 ? aggregator : 'data', unscope ? (0, utils_1.last)(name.split('.')) : name, acc.allData[name]);
        }
        return acc;
    }, { data: {}, toAggregate: {}, allData: {} });
}
exports.buildFormData = buildFormData;
function buildDeepChildren(name, aggregators) {
    var _a, _b;
    const children = {};
    for (const [n, agg] of Object.entries((_b = (_a = aggregators[name]) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : {})) {
        if (aggregators[n]) {
            children[n] = Object.assign(aggregators[n], {
                children: buildDeepChildren(n, aggregators),
            });
        }
        else {
            children[n] = agg;
        }
    }
    return children;
}
function normalizeAggregators(aggregators) {
    const normalizedAggregators = {};
    for (const [name, agg] of Object.entries(aggregators)) {
        if (agg.children) {
            normalizedAggregators[name] = Object.assign(agg, {
                children: buildDeepChildren(name, aggregators),
            });
        }
        else {
            normalizedAggregators[name] = agg;
        }
    }
    return normalizedAggregators;
}
exports.normalizeAggregators = normalizeAggregators;
function resolveAggregator(aggregators, nodeName, aggregator, toAggregate, invalidAggregators, acc = {}) {
    var _a, _b;
    if (!aggregator) {
        return;
    }
    if (aggregator.children) {
        if (!toAggregate[nodeName]) {
            Object.assign(toAggregate, { [nodeName]: {} });
        }
        (0, utils_1.map)((_child, childName) => resolveAggregator(aggregators, childName, aggregators[childName], toAggregate, invalidAggregators, toAggregate[nodeName]), aggregator.children);
    }
    const isAggregatorDataValid = (_b = (_a = aggregator.validate) === null || _a === void 0 ? void 0 : _a.call(aggregator, toAggregate[nodeName])) !== null && _b !== void 0 ? _b : true;
    if ((invalidAggregators === null || invalidAggregators === void 0 ? void 0 : invalidAggregators.has(nodeName)) || !isAggregatorDataValid) {
        throw new Error('INVALID_AGGREGATOR_DATA');
    }
    if (aggregator.aggregate && toAggregate[nodeName]) {
        const resolvedValue = aggregator.aggregate(toAggregate[nodeName]);
        Object.assign(acc, { [nodeName]: resolvedValue });
    }
}
exports.resolveAggregator = resolveAggregator;
function resolveAggregators(aggregators, toAggregate, invalidAggregators) {
    const acc = {};
    for (const [name, aggregator] of Object.entries(aggregators)) {
        if (!aggregator) {
            continue;
        }
        resolveAggregator(aggregators, name, aggregator, toAggregate, invalidAggregators, acc);
    }
    return acc;
}
exports.resolveAggregators = resolveAggregators;
function initDefaultInputs(defaultValues) {
    return Object.fromEntries(Object.entries(defaultValues).map(([name, value]) => [
        name,
        (0, exports.defaultController)(value),
    ]));
}
exports.initDefaultInputs = initDefaultInputs;
